import { findTherapeuticAreas } from '~/Api/Analytics/Autocomplete/TherapeuticArea';
import { invokeApi, tryResolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectTherapeuticAreas, State } from './reducer';

export function loadTherapeuticAreas(filter: string): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		const normalizedFilter = filter.slice(0, 1);
		const therapeuticAreas = selectTherapeuticAreas(
			getState().medicinalBrandsAnalyticsTherapeuticAreaAutocomplete,
			normalizedFilter
		);
		await (therapeuticAreas || dispatch(fetchTherapeuticAreas(normalizedFilter)));
	};
}

export function fetchTherapeuticAreas(filter: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findTherapeuticAreas, filter));
		dispatch({ type: ActionTypes.request, request, filter });
		tryResolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				filter,
				items: response?.items,
			})
		);
	};
}
